import { Box, Container } from '@mui/system'
import React from 'react'
import boxStyles from '../../../styles/boxStyles'
import FooterReviewVp from '../Component/FooterReviewVp'
import KemungkinanPenyebab from '../Component/KemungkinanPenyebab'
import PotensiOutcome from '../Component/PotensiOutcome'

const ReviewVpAsset = () => {
    return (
        <div>
            <Container maxWidth={false}>
                <center><h2>LAPORAN KEJADIAN PENTING</h2></center>
                <Box component="div" sx={boxStyles}>
                    <PotensiOutcome />
                    <KemungkinanPenyebab />
                </Box>
                <br></br>
                <FooterReviewVp />
            </Container>
        </div>
    )
}

export default ReviewVpAsset